module.exports = __webpack_public_path__ + "static/img/logo4.2f2c8420.jpg";